import { unlabeled } from '../../entities';
import type { RoiFilterStep, RoiFilterStrategyContext } from './roi-filter.types';

export function applyLabelFilter(step: RoiFilterStep, ctx: RoiFilterStrategyContext): Set<string> | undefined {
  if (step.value.toLowerCase() === unlabeled) {
    return ctx.labelIndex.get(unlabeled) ?? new Set();
  }
  const label = Object.values(ctx.labels).find((l) => l.name === step.value);
  if (!label) return undefined;
  const filteredRois = ctx.previousRois.filter((roi) => roi.labels.has(label.id));
  return new Set(filteredRois.map((roi) => roi.id));
}
